import { Provider } from 'react-redux';
import { StyleSheetManager } from 'styled-components';
import { LicenseInfo } from '@mui/x-license-pro';

import { theme, Toast } from '@vivaahealth/design-system';

import { getOrCreateStore } from './reducers/store';
import { Router } from './scenes/router';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import './App.css';
import '@vivaahealth/design-system/dist/index.css';

import './styles/design-system/button.css';

const MUI_PUBLIC_LICENSE_KEY =
  'f572a01c273d3b6f66c206111dce6684Tz04NTM4OSxFPTE3NDA4NTI0MTgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=';
const store = getOrCreateStore();

LicenseInfo.setLicenseKey(MUI_PUBLIC_LICENSE_KEY);

export function ReduxApp() {
  return (
    <StyleSheetManager enableVendorPrefixes>
      <theme.ThemeProvider>
        <Provider store={store}>
          <Toast.ToastProvider>
            <Router />
          </Toast.ToastProvider>
        </Provider>
      </theme.ThemeProvider>
    </StyleSheetManager>
  );
}
